export const operators = {
  field: {
    url: 'URL',
    id: 'ID',
    type: 'Тип',
    login: 'Логин',
    pass: 'Пароль',
    campaigns_name: 'Кампании',
    weight: 'Вес оператора',
    status: 'Статус',
    wrtc: 'WRTC',
    instance: 'Сервер',
    created_at: 'Дата создания'
  },

  button: {
    create: 'Создать оператора',
    disabled: 'Все вебхуки уже созданы'
  },

  modal: {
    create: 'Создание оператора',
    edit: 'Изменение оператора',
    remove: {
      content: 'Вы уверены, что хотите удалить оператора {type}?'
    },
    change_status: {
      enable: 'Вы уверены, что хотите активировать оператора?',
      disable: 'Вы уверены, что хотите деактивировать оператора?'
    }
  },

  tooltip: {
    delete: 'Удалить навык оператора'
  },
  error: {
    create_project: 'Не удалось создать продукт',
    unique_create_project: 'Продукт с таким названием уже существует',
    create_skill: 'Не удалось создать навык',
    edit_skill: 'Не удалось изменить навык'
  },
  skills: {
    title: 'Навыки оператора',
    add: '+ Добавить навык оператора',
    product: 'Продукт',
    weight: 'Значение навыка',
    create: 'Создать продукт',
    edit: 'Редактировать продукт',
    name: 'Название продукта',
  }
};
